import { reactive } from 'vue'
import { io } from 'socket.io-client'

export const state = reactive({
  connected: false
})

// "undefined" means the URL will be computed from the `window.location` object
const URL = 'https://uat-api-ttb.zwiz.app'
// process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:3000'

export const socket = io(URL, {
  autoConnect: false
})

socket.on('connect', () => {
  console.log('socket is connected')
  state.connected = true
})

socket.on('disconnect', () => {
  console.log('socket is disconnected')
  state.connected = false
})



// WEBPACK FOOTER //
// ./src/utils/socket.io.js